import { HTTP_METHODS } from '@app/configs/api';
import { TERMS_AND_CONDITIONS_ENDPOINTS } from '@app/configs/api/termsAndConditions';
import { getInvestorLocale } from '@app/utils/getInvestorLocale';
import { getUserLocale } from '@app/utils/getUserLocale';
import { baseApi } from './baseApi';
import { TAG_TYPES } from './tagTypes';
export const termsAndConditionsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getTermsAndConditions: builder.query({
            query: (type) => ({
                url: TERMS_AND_CONDITIONS_ENDPOINTS.borrowerTermsAndConditions + type,
                params: {
                    locale: getUserLocale(),
                },
            }),
            providesTags: [TAG_TYPES.TERMS_AND_CONDITIONS],
        }),
        acceptTermsAndConditions: builder.mutation({
            query: (data) => ({
                url: TERMS_AND_CONDITIONS_ENDPOINTS.acceptTermsAndConditions,
                method: HTTP_METHODS.PUT,
                body: { documentIds: data },
                params: { locale: getInvestorLocale() },
            }),
            invalidatesTags: [TAG_TYPES.TERMS_AND_CONDITIONS, TAG_TYPES.FUNCTIONALITIES],
        }),
    }),
    overrideExisting: false,
});
export const { useGetTermsAndConditionsQuery, useAcceptTermsAndConditionsMutation } = termsAndConditionsApi;
